import { render } from "./MyAccountPage.vue?vue&type=template&id=8a194878"
import script from "./MyAccountPage.vue?vue&type=script&lang=js"
export * from "./MyAccountPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/azai-web/azaitech-website-template-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__